import React, { useState } from 'react';

export const ShowReportsContext:any = React.createContext({});
export const ShowReportsContextProvider = (props: { children: React.ReactNode }) => {
	const [ShowReports, setShowReports] = useState(false);
	return (
		<ShowReportsContext.Provider
			value={{
				data: ShowReports,
				set: (e) => {
					setShowReports(e);
				},
				setShowReports:setShowReports
			}}
		>
			{props.children}
		</ShowReportsContext.Provider>
	);

};